export const pbSheetExampleOpt = {
  chart: {
    backgroundColor: '#F2F5F9',
    type: 'packedbubble',
  },
  title: {
    text: '',
  },
  legend: { enabled: false },
  colors: ['rgba(91, 75, 183, 1)', 'rgba(91, 75, 183, 0.7)'],
  tooltip: {
    useHTML: true,
    pointFormat:
      '<b>{point.name}:</b> {point.value}% <br /> <i>{point.valueShare}</i> ',
  },
  plotOptions: {
    packedbubble: {
      minPointLength: 1,
      marker: {
        lineColor: 'transparent',
      },
      minSize: '40%',
      maxSize: '100%',
      layoutAlgorithm: {
        splitSeries: false,
        gravitationalConstant: 0.035,
      },
      dataLabels: {
        enabled: true,
        format: '<b>{point.name}</b>',
        formatter: function () {
          if (this.y !== 0) {
            return this.y
          }
        },
        filter: {
          property: 'y',
          operator: '>',
          value: 1,
        },
        style: {
          color: 'black',
          textOutline: 'none',
          fontWeight: 'normal',
          'word-break': 'break-word',
          width: 50,
        },
      },
    },
  },
  data: {
    googleAPIKey: 'AIzaSyCJ1tR4o2tswyM7U2-O96A1F1CYLR2BHX0',
    googleSpreadsheetKey: '13DurQVuHS0mxhwRpZ0eba-8wd-u5NVbijp8KGVHnjkw',
    error: console.error,
  },
}
